import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    addScollClass,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


import '../woocommerce/js/woocommerce';

import GLightbox from 'glightbox';




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');
    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder').animate({ 'scrollTop': '0px' }, 0);
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (window.innerWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                console.log(target);
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    console.log($(target).offset().top, targetOffset);
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }




        //rotator and sliders..
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                fade: true,
                cssEase: 'linear'
            });

        }

        const lightbox = GLightbox({
            selector: ".glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });






    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








